import axios from "axios";
import * as types from "../mutation-types";
import logger from "~/utilities/logger";

// state
export const state = {
  activity_descriptions_list: [],
};

// getters
export const getters = {
  activity_descriptions_list: (state) => state.activity_descriptions_list,
};

// mutations
export const mutations = {
  [types.FETCH_ACTIVITY_DESCRIPTIONS](state, { activity_descriptions_list })
  {
    state.activity_descriptions_list = activity_descriptions_list;
  },

  [types.FETCH_ACTIVITY_DESCRIPTIONS_FAILURE](state)
  {
    logger.error("FETCH_ACTIVITY_DESCRIPTIONS_FAILURE");
  },

  [types.CREATE_ACTIVITY_DESCRIPTION](state, { description })
  {
    state.activity_descriptions_list.unshift(description);
  },

  [types.CREATE_ACTIVITY_DESCRIPTION_FAILURE](state)
  {
    logger.error("CREATE_ACTIVITY_DESCRIPTION_FAILURE");
  },

  [types.UPDATE_ACTIVITY_DESCRIPTION](state, { description })
  {
    const index = state.activity_descriptions_list.findIndex(
      (d) => d.actdesc_id === description.actdesc_id
    );
    if (index !== -1)
    {
      state.activity_descriptions_list.splice(index, 1, description);
    }
  },

  [types.UPDATE_ACTIVITY_DESCRIPTION_FAILURE](state)
  {
    logger.error("UPDATE_ACTIVITY_DESCRIPTION_FAILURE");
  },

  [types.DELETE_ACTIVITY_DESCRIPTION](state, { id })
  {
    state.activity_descriptions_list = state.activity_descriptions_list.filter(
      (d) => d.actdesc_id !== id
    );
  },

  [types.DELETE_ACTIVITY_DESCRIPTION_FAILURE](state)
  {
    logger.error("DELETE_ACTIVITY_DESCRIPTION_FAILURE");
  },
};

// actions
export const actions = {
  async fetchActivityDescriptions({ commit }, { act_id } = {})
  {
    try
    {
      const params = new URLSearchParams({ paginate: 10000 });
      if (act_id) params.set("act_id", act_id);

      const { data } = await axios.get(`/api/activity-descriptions?${params}`);

      if (data?.status !== "success") throw data;

      const activity_descriptions_list = data.data?.data ?? data.data ?? [];

      commit(types.FETCH_ACTIVITY_DESCRIPTIONS, { activity_descriptions_list });

      return activity_descriptions_list;
    } catch (e)
    {
      logger.error("fetchActivityDescriptions", e);
      commit(types.FETCH_ACTIVITY_DESCRIPTIONS_FAILURE);
      throw e;
    }
  },

  async fetchActivityDescriptionsByProject({ commit }, { act_id, pro_id, include_global = false } = {}) {

    try
    {
      const params = new URLSearchParams({ paginate: 10000 });
      if (act_id) params.set("act_id", act_id);
      if (pro_id) params.set("pro_id", pro_id);
      if (include_global) params.set("include_global", include_global);
      
      const { data } = await axios.get(`/api/activity-descriptions?${params}`);

      if (data?.status !== "success") throw data;

      const activity_descriptions_list = data.data?.data ?? data.data ?? [];

      commit(types.FETCH_ACTIVITY_DESCRIPTIONS, { activity_descriptions_list });

      return activity_descriptions_list;
    } catch (e)
    {
      logger.error("fetchActivityDescriptionsByProject", e);
      commit(types.FETCH_ACTIVITY_DESCRIPTIONS_FAILURE);
      throw e;
    }

  },

  async createActivityDescription({ commit }, payload)
  {
    try
    {
      const { data } = await axios.post("/api/activity-descriptions", payload);

      if (data?.status !== "success") throw data;

      const description = data.data;
      commit(types.CREATE_ACTIVITY_DESCRIPTION, { description });

      return description;
    } catch (e)
    {
      logger.error("createActivityDescription", e);
      commit(types.CREATE_ACTIVITY_DESCRIPTION_FAILURE);
      throw e;
    }
  },

  async updateActivityDescription({ commit }, { id, payload })
  {
    try
    {
      const { data } = await axios.put(`/api/activity-descriptions/${id}`, payload);

      if (data?.status !== "success") throw data;

      const description = data.data;
      commit(types.UPDATE_ACTIVITY_DESCRIPTION, { description });

      return description;
    } catch (e)
    {
      logger.error("updateActivityDescription", e);
      commit(types.UPDATE_ACTIVITY_DESCRIPTION_FAILURE);
      throw e;
    }
  },

  async deleteActivityDescription({ commit }, id)
  {
    try
    {
      const { data } = await axios.delete(`/api/activity-descriptions/${id}`);

      if (data?.status !== "success") throw data;

      commit(types.DELETE_ACTIVITY_DESCRIPTION, { id });

      return data;
    } catch (e)
    {
      logger.error("deleteActivityDescription", e);
      commit(types.DELETE_ACTIVITY_DESCRIPTION_FAILURE);
      throw e;
    }
  },


};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
